import React, { Component } from "react";
import { monthOptions, yearOptions } from "../config";
import { configDailySalesReportBySalesman, getConfigDaily } from "./confg";
import FlexView from "react-flexview";
import * as R from "ramda";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../../../common/mapper";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleNestedTable from "../../../../../modules/SimpleNestedTable";
import { HttpStatus } from "../../../../common/Constants";
import moment from "moment";

class DailySalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
      dataTL: [],
      dataSales: [],
      teamLead: null,
      sales: null,
    };
  }

  componentDidMount = async () => {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      ...prevValue,
      // month: monthOptions.find((item) => item.value === currentDate.getMonth()),
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      tableConfig: !this.props.tab
        ? getConfigDaily()
        : this.props.tab === "salesman"
          ? configDailySalesReportBySalesman
          : [],
    }));

    if (!R.isNil(this.props.kodeCabang?.value)) {
      if (!this.props.tab) {
        await this.fetchDataTL();
      } else if (this.props.tab === "salesman") {
        await this.fetchDataSales();
      }
    }
  };

  componentDidUpdate = async (prevProps) => {
    const prevCabang = prevProps.kodeCabang?.value;
    const currCabang = this.props.kodeCabang?.value;

    if (prevCabang !== currCabang && currCabang) {
      this.setState({
        teamLead: null,
        sales: null,
        dataTL: [],
        dataSales: [],
      });

      if (!this.props.tab) {
        await this.fetchDataTL();
      } else if (this.props.tab === "salesman") {
        await this.fetchDataSales();
      }
    }
  };

  fetchDataTL = async () => {
    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Sales",
        args: {
          paramFilters: {
            kodeCabang: this.props.kodeCabang?.value,
            userNameLead: this.props.usernameLogin,
          },
        },
      });
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTL: res.data.data,
        }));
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  fetchDataSales = async () => {
    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSalesDropdownForDashboard,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Sales",
        args: { employeeIdTeamLeader: this.props.idLeader, kodeCabang: this.props.kodeCabang?.value },
      });
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataSales: res.data.data,
        }));
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  transformResponseDataReportHarian = (data) => {
    const transformed = data.map((item) => {
      const { dataSalesDaily = {}, ...rest } = item;
      return {
        ...rest,
        ...dataSalesDaily,
      };
    });
    return transformed;
  };

  fetchDataReportHarian = async () => {
    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarianPerCabang,
        setError: this.props.setError,
        menuName: "Dashboard Kacab Keatas - Laporan Jual Harin Sales",
        args: {
          kodeCabang: [this.props.kodeCabang.value],
          year: this.state.year?.value,
          month: this.state.month?.value,
          employeeIdTeamLeader: this.state.teamLead?.value,
          team: true,
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: this.transformResponseDataReportHarian(res.data.data),
        }));
      }
      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("Error Fetching", error);
    }
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  formatDate = (days, month, year) =>
    moment(`${days}-${month}-${year}`, "DD-MM-YYYY").format("DD/MM/YYYY");

  constructConfig(value) {
    if (!value?.dataSalesDaily?.length) return [];

    const config = value.dataSalesDaily.map((item) => ({
      key: item.leasingName || item.paymentMethod,
      label: item.leasingName || item.paymentMethod,
      percentSP: item.leasingName ? item.dailyPercentMSCP : item.dailyPercentSP,
      ...item,
    }));

    // Add total row
    config.push({
      key: "total",
      label: "Total",
      dailyCash: value.totalDailyCash,
      dailyAccumulation: value.totalDailyAccumulation,
      percentSP: null,
    });

    return config;
  }

  fetchDataDataHarianSalesman = async () => {
    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarian,
        setError: this.props.setError,
        menuName: "Dashboard Kacab Keatas - Laporan Jual Harin By Salesman",
        args: {
          kodeCabang: [this.props.kodeCabang.value],
          year: this.state.year?.value,
          month: this.state.month?.value,
          employeeIdTeamLeader: this.state.sales?.value,
          team: false,
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const daysCount = Object.keys(
          res.data.data?.totalDailyCash || {},
        ).length;

        this.setState((prevValue) => ({
          ...prevValue,
          tableConfig: this.constructConfig(res.data.data),
          dataTable: Array.from({ length: daysCount }, (_, i) =>
            this.formatDate(
              i + 1,
              this.state.month?.value,
              this.state.year?.value,
            ),
          ),
        }));
      }
      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("Error Fetching", error);
    }
  };

  handleSearch = () => {
    if (!this.props.tab) {
      const { month, year } = this.state;
      this.setState({
        tableConfig: getConfigDaily(month?.value, year?.value),
      });
      this.fetchDataReportHarian();
    } else if (this.props.tab === "salesman") {
      this.fetchDataDataHarianSalesman();
    }
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            isClearable
            containerclassname="width width-250px"
            placeholder="Bulan"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            isClearable
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          {!this.props.tab && (
            <SimpleDDL
              id="select_options_team_lead"
              box="search"
              isClearable
              name="teamLead"
              containerclassname="width width-250px"
              placeholder="Nama TL"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              options={this.state.dataTL.map((item) =>
                mapToObjectDDL(item.salesLeadName, item.employeeId),
              )}
              value={this.state.teamLead}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
          )}
          {this.props.tab === "salesman" && (
            <SimpleDDL
              id="select_options_sales"
              box="search"
              name="sales"
              isClearable
              containerclassname="width width-250px"
              placeholder="Nama Sales/CS"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              options={this.state.dataSales.map((item) =>
                mapToObjectDDL(item.name, item.employeeId),
              )}
              value={this.state.sales}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
          )}
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {this.props.tab === "salesman" ? (
          <SimpleNestedTable
            data={this.state.dataTable}
            config={this.state.tableConfig}
          />
        ) : (
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
          />
        )}
      </>
    );
  }
}

export default DailySalesReport;
